import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';

declare var moment: any;

@Injectable()
export class UtilityService {
  private _router: Router;

  constructor(router: Router) {
    this._router = router;
  }

  convertDateTime(date: Date) {
    const _formattedDate = new Date(date.toString());
    return _formattedDate.toDateString();
  }

  /**
   * Chuyển chuỗi có định dạng bất kỳ về định dạng được quy định
   * @param dateString
   * @param inputFormat
   * @param outputFormat
   * @returns string
   */
  convertStringAnyToStringDate(dateString: string, inputFormat: string, outputFormat: string = 'YYYYMMDD'): string {
    // if (this.isValidDateString2(dateString, inputFormat)) {
    return moment(dateString, inputFormat).format(outputFormat);
    // } else {
    //   return '';
    // }
  }

  /**
   * Chuyển chuỗi ngày tháng dạng DD/MM/YYYY về YYYYMMDD
   * @param dateString dd/mm/yyyy format (ex: 31/01/2019)
   * @returns yyyymmdd string (ex: 20190131)
   */
  convertToStringDate(dateString: string): string {
    if (this.isValidDateString2(dateString)) {
      return moment(dateString, 'DD/MM/YYYY').format('YYYYMMDD');
    } else {
      return '';
    }
  }

  /**
 * Chuyển chuỗi ngày tháng dạng YYYYMMDD về DD/MM/YYYY
 * @param dateString yyyymmdd format (ex: 20190131)
 * @returns dd/mm/yyyy string (ex: 31/01/2019)
 */
  convertToStringDate2(dateString: string): string {
    return moment(dateString, 'YYYYMMDD').format('DD/MM/YYYY');
  }

  /**
   * Chuyển chuỗi ngày tháng dạng YYYYMMDD về kiểu Date()
   * @param dateString yyyymmdd format (ex: 20190131)
   * @returns Date object
   */
  convertStringToDate(dateString: string): Date {
    if (dateString) {
      return moment(dateString, 'YYYYMMDD').toDate();
    } else {
      return new Date();
    }
  }

  /**
   * Kiểm tra tính hợp lệ của chuỗi ngày tháng dạng YYYYMMDD
   * @param dateString chuỗi ngày tháng dạng YYYYMMDD
   */
  isValidDateString(dateString: string): boolean {
    return moment(dateString, 'YYYYMMDD').isValid();
  }

  /**
   * Kiểm tra tính hợp lệ của chuỗi ngày tháng
   * @param dateString chuỗi ngày tháng dạng
   * @param format định dạng kiểm tra
   */
  isValidDateString2(dateString: string, format: string = 'DD/MM/YYYY'): boolean {
    if (dateString !== undefined && dateString !== null && dateString.trim() !== '' && dateString.length === 10) {
      return moment(dateString, format).isValid();
    } else {
      return false;
    }
  }

  /**
   * Chuyển date object về chuỗi ngày tháng dạng YYYYMMDD
   * @param date
   */
  convertDateToString(date: Date, format = 'YYYYMMDD') {
    return moment(date).format(format);
  }

  /**
 * Chuyển date object về chuỗi ngày tháng dạng DD/MM/YYYY
 * @param date
 */
  convertDateToString2(date: Date) {
    return moment(date).format('DD/MM/YYYY');
  }

  /**
   * Chuyển date object về chuỗi thời gian dạng hh:mm
   * @param date
   */
  convertDateToStringTime(date: Date) {
    return moment(date).format('HH:mm');
  }

  isEmptyString(str) {
    if (!str || 0 === str.length || str.trim() === '') {
      return true;
    } else {
      return false;
    }
  }

  isZeroNumber(i) {
    if (!i || i === 0) {
      return true;
    } else {
      return false;
    }
  }

  navigate(path: string) {
    this._router.navigate([path]);
  }

  navigateWithParam(path: string, param: any[]) {
    this._router.navigate([path, ...param]);
  }

  navigateToLogin() {
    this._router.navigate([`/login`]);
  }

  Unflatten = (arr: any[]): any[] => {
    const map = {};
    const roots: any[] = [];
    for (let i = 0; i < arr.length; i += 1) {
      const node = arr[i];
      node.children = [];
      map[node.Id] = i; // use map to look-up the parents
      if (node.ParentId !== null) {
        arr[map[node.ParentId]].children.push(node);
      } else {
        roots.push(node);
      }
    }
    return roots;
  }

  Unflatten2 = (arr: any[]): any[] => {
    const map = {};
    const roots: any[] = [];
    for (let i = 0; i < arr.length; i += 1) {
      const node = arr[i];
      node.children = [];
      map[node.ID] = i; // use map to look-up the parents
      if (node.ParentID !== null) {
        arr[map[node.ParentID]].children.push(node);
      } else {
        roots.push(node);
      }
    }
    return roots;
  }

  MakeSeoTitle(input: string) {
    if (input === undefined || input === '') {
      return '';
    }
    // Đổi chữ hoa thành chữ thường
    let slug = input.toLowerCase();

    // Đổi ký tự có dấu thành không dấu
    slug = slug.replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, 'a');
    slug = slug.replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, 'e');
    slug = slug.replace(/i|í|ì|ỉ|ĩ|ị/gi, 'i');
    slug = slug.replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, 'o');
    slug = slug.replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, 'u');
    slug = slug.replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, 'y');
    slug = slug.replace(/đ/gi, 'd');
    // Xóa các ký tự đặt biệt
    slug = slug.replace(/\`|\~|\!|\@|\#|\||\$|\%|\^|\&|\*|\(|\)|\+|\=|\,|\.|\/|\?|\>|\<|\'|\"|\:|\;|_/gi, '');
    // Đổi khoảng trắng thành ký tự gạch ngang
    slug = slug.replace(/ /gi, '-');
    // Đổi nhiều ký tự gạch ngang liên tiếp thành 1 ký tự gạch ngang
    // Phòng trường hợp người nhập vào quá nhiều ký tự trắng
    slug = slug.replace(/\-\-\-\-\-/gi, '-');
    slug = slug.replace(/\-\-\-\-/gi, '-');
    slug = slug.replace(/\-\-\-/gi, '-');
    slug = slug.replace(/\-\-/gi, '-');
    // Xóa các ký tự gạch ngang ở đầu và cuối
    slug = '@' + slug + '@';
    slug = slug.replace(/\@\-|\-\@|\@/gi, '');

    return slug;
  }

  /**
   * Mã hóa
   * @param msg 
   * @param pass 
   */
  encrypt(msg, pass) {
    // random salt for derivation
    var keySize = 256;
    var salt = CryptoJS.lib.WordArray.random(16);
    // well known algorithm to generate key
    var key = CryptoJS.PBKDF2(pass, salt, {
      keySize: keySize / 32,
      iterations: 100
    });
    // random IV
    var iv = CryptoJS.lib.WordArray.random(128 / 8);
    // specify everything explicitly
    var encrypted = CryptoJS.AES.encrypt(msg.toString(), key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    });
    // combine everything together in base64 string
    var result = CryptoJS.enc.Base64.stringify(salt.concat(iv).concat(encrypted.ciphertext));
    return result;
  }

  generateUUID(): string {
    if (window.crypto && (window.crypto as any).randomUUID) {
      return (window.crypto as any).randomUUID();
    }
    // fallback
    return 'xxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}



// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/services/utility.service.ts